import { COLORS } from "./colors";

export const themes = [
  { id: "light", name: "Світла", active: [COLORS.blue, COLORS.secondary1] },
  {
    id: "dark",
    name: "Темна",
    active: [COLORS.secondary1, COLORS["light-gray"]],
  },
  {
    id: "default",
    name: "Авто",
    active: [COLORS["bg-text-color"], COLORS.white],
  },
];

export enum ActionsEnum {
  ADD = "add",
  EDIT = "edit",
  DELETE = "delete",
  EXIT = "exit",
  RESTORE = "restore",
  ARCHIVE = "archive",
  CONFIRM_KANBAN_MOVING = "confirm kanban card moving"
}

export type WorkingSettingsStep = {
  id: number;
  title: string;
  subtitle?: string;
  path: string;
};

export type WorkingSettingsStepperProps = {
  steps: WorkingSettingsStep[];
  activeStepId: number;
};

// export const steps: WorkingSettingsStep[] = [
//   {
//     id: 1,
//     title: "Назва",
//     subtitle: "Назвіть вашу команду",
//   },
//   {
//     id: 2,
//     title: "Структура",
//     subtitle: "Виберіть шаблон системи",
//   },
//   {
//     id: 3,
//     title: "План підписки",
//     subtitle: "Оберіть план для вашої CRM",
//   },
//   {
//     id: 4,
//     title: "Завершення онбордингу",
//     subtitle: "Ваша CRM готова до роботи",
//   },
// ];

export type WorkingSettingsStepStatus = "completed" | "active" | "upcoming";

export enum WorkingSettingsStepEnum {
  NAME = "name",
  STRUCTURE = "structure",
  PLAN = "plan",
  FINISH = "finish"
}

export function getStepStatus(stepId: number, activeStep: number): WorkingSettingsStepStatus {
  if (stepId < activeStep) return "completed";
  if (stepId === activeStep) return "active";
  return "upcoming";
}
